import { render } from "./DonatursCard.vue?vue&type=template&id=ac3130f4"
import script from "./DonatursCard.vue?vue&type=script&lang=js"
export * from "./DonatursCard.vue?vue&type=script&lang=js"
script.render = render

export default script